import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "common-layout" }

import peopleheadmenu from "@/inc/peopleheader.vue";




export default /*@__PURE__*/_defineComponent({
  __name: 'peoplepage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_container = _resolveComponent("container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(peopleheadmenu)
        ]),
        _createVNode(_component_router_view)
      ]),
      _: 1
    })
  ]))
}
}

})